import { render } from "./role_master.vue?vue&type=template&id=9d4ade6a&scoped=true"
import script from "./role_master.vue?vue&type=script&lang=js"
export * from "./role_master.vue?vue&type=script&lang=js"

import "./role_master.vue?vue&type=style&index=0&id=9d4ade6a&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\TRAVEL SAFE\\kite-app-api\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d4ade6a"]])

export default __exports__